import React from "react";

import Seo from "../components/seo";
import Layout from "../components/layout";
import Hero from "../components/hero";
import Services from "../components/services";
import About from "../components/about";
import Works from "../components/works";
import Prices from "../components/prices";

const IndexPage = () => (
  <Layout>
    <Seo />
    <Hero />
    <About />
    <Services />
    <Works />
    <Prices />
  </Layout>
);

export default IndexPage;
